// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import HoaDuesInput from '../hoa-dues';

const HoaDuesInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <HoaDuesInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default HoaDuesInputWithAnalytics;
